import { InjectionToken, ValueProvider } from '@angular/core';
import { Environment } from '../models/environment';

export const ENVIRONMENT_CONFIG = new InjectionToken<Environment>('movinmotion-frontend.config');
export const COMPTA_API_PATH = '/api/compta/v1';
export const getEnvironmentProvider = (value: Environment): ValueProvider => ({
  provide: ENVIRONMENT_CONFIG,
  useValue: value,
});
